export default __webpack_public_path__ + "static/media/Intimation of Newspaper Advertisement.b852f823.pdf";